import {
    useCallback,
    useState,
} from "react";


const useBatchEntryState = () => {

    // =========================================================
    // Draft Batch Entry State
    //
    // These values are NOT saved directly.
    // They are only applied to local student assessment state.
    // =========================================================

    const [
        selectedSkillIds,
        setSelectedSkillIds,
    ] = useState([]);

    const [
        dokProficiency,
        setDokProficiency,
    ] = useState({});

    const [
        overallAssessment,
        setOverallAssessment,
    ] = useState("");


    // =========================================================
    // Toggle Skill
    // =========================================================

    const toggleSkill = useCallback(
        (skillId) => {

            setSelectedSkillIds(
                (previous) => {

                    if (
                        previous.includes(
                            skillId
                        )
                    ) {
                        return previous.filter(
                            (id) =>
                                id !== skillId
                        );
                    }

                    return [
                        ...previous,
                        skillId,
                    ];
                }
            );
        },
        []
    );


    // =========================================================
    // Set DOK Proficiency
    // =========================================================

    const setDOKProficiency =
        useCallback(
            (
                dokLevel,
                proficiency
            ) => {

                setDokProficiency(
                    (previous) => ({
                        ...previous,
                        [dokLevel]:
                            proficiency,
                    })
                );
            },
            []
        );


    // =========================================================
    // Clear Batch Entry
    // =========================================================

    const clearBatchEntry =
        useCallback(() => {

            setSelectedSkillIds(
                []
            );

            setDokProficiency(
                {}
            );

            setOverallAssessment(
                ""
            );

        }, []);


    // =========================================================
    // Does Batch Entry contain anything to apply?
    // =========================================================

    const hasBatchChanges =
        selectedSkillIds.length > 0 ||
        Object.values(
            dokProficiency
        ).some(Boolean) ||
        Boolean(
            overallAssessment
        );


    return {
        selectedSkillIds,
        dokProficiency,
        overallAssessment,

        toggleSkill,
        setDOKProficiency,
        setOverallAssessment,

        clearBatchEntry,

        hasBatchChanges,
    };
};


export default useBatchEntryState;